// extracted by mini-css-extract-plugin
var _1 = "nJV4cOx9";
var _2 = "aUdTHFVw";
var _3 = "SURRuyRl";
var _4 = "m6dnm0Ym";
var _5 = "fCjcQ6PL";
var _6 = "lWsxA2A7";
var _7 = "RjYUheAR expanded-box";
var _8 = "RjYUheAR expanded-box";
var _9 = "pGLTOecR";
export { _1 as "beige", _2 as "grey", _3 as "left", _4 as "nothing", _5 as "pink", _6 as "right", _7 as "textbox-with-color", _8 as "textboxWithColor", _9 as "yellow" }
